import React from 'react';
//material
import {withStyles, Grid, IconButton} from '@material-ui/core';
//styles
import styles from '../rich-text-editor-wrapper/rich-text-editor-wrapper-styles';
import CreateIcon from '@material-ui/icons/Create';
import ClearIcon from '@material-ui/icons/Clear';
import CheckIcon from '@material-ui/icons/Check';
//components
import Editor from '../rich-text-editor';

const RichTextEditorWrapperView = (props) => {

  const {
    classes, 
    displayEdit,
    text, 
    editText, 
    setNewText, 
    setEditText,
    emptyText,
    save
  } = props;
  
  return (
    <Grid container className={classes.editTextContainer}>
      {
      editText ?
      <Grid item xs={12} md={11} className={classes.editTextEditContainer}>
        <Editor setNewText={setNewText} initialValue={text} />
      </Grid> :
      <Grid item xs={12} md={11} className={classes.editTextViewContainer}>
        <div
          className={classes.text}
          dangerouslySetInnerHTML={{ __html: text ? text : emptyText }}/>
      </Grid>
      }
      {
        displayEdit ?       
        <Grid item xs={12} md={1} className={editText ? classes.editTextActionEndContainer : classes.editTextActionStartContainer}>
        {
          editText ? 
          <>
          <IconButton className={classes.editTextButton} onClick={() => save()}>
            <CheckIcon />
          </IconButton> 
          <IconButton className={classes.editTextButton} onClick={() => setEditText(false)}>
            <ClearIcon />
          </IconButton> 
          </> :
          <IconButton className={classes.editTextButton} onClick={() => setEditText(true)}>
            <CreateIcon />
          </IconButton>
        }
        </Grid> : <></>
      }

    </Grid>
  );
};

export default withStyles(styles) (RichTextEditorWrapperView) ;
